export const COMPLETED_ICF_VALUES = 'COMPLETED_ICF_VALUES';
export const COMPLETED_ICF_TITLE = 'Completed Informed Consents';

export const defaultPage = 0;
export const defaultPageSize = 25;
export const defaultSorted = [{ id: 'dateRecorded', desc: true }];
